/**
 * 引入POST、BASE_URL
 * @param params
 * @returns {*}
 */
export const uplUrl = "https://api.future.welaiedu.cn/future"

// export const urls = "https://test.api.future.welaiedu.cn/evaluate"
// export const fuUrl = "https://test.api.future.welaiedu.cn/future"

export const urls="https://api.future.welaiedu.cn/evaluate"
export const fuUrl = "https://api.future.welaiedu.cn/future"

//export const urls="http://192.168.1.180:9002/evaluate"
//export const urls="http://192.168.1.113:9002/evaluate"
import { POST, BASE_URL, chuli } from '../api/index'

//用户登录接口
export function userlogin(params) {
	return POST(urls + '/user/login', params, 'post', '', 4)
}

//退出登录
export function UserLogout() {
	return POST(urls + '/user/logout', '', 'post', '')
}

//获取登陆用户信息
export function usercenterinfo() {
	return POST(urls + '/usercenter/get-info', '', 'get', '')
}
//获取学校详细信息
export function schoolgetinfo(params) {
	return POST(urls + '/school/get-info', params, 'get', '')
}
//根据学段获取年级
export function gradelist(params){
	return POST(urls + '/grade/stage-list?stage=1',params,'get','');
}
//获取在线课堂日历课程表
export function courseonlinelist(params) {
	return POST(fuUrl + '/course/on-line/list', params, 'get', '')
}
//获取教材章节树
export function bookgetchaptertree(params) {
	return POST(fuUrl + '/book/getchaptertree', params, 'get', '')
}
//获取教材章节树
export function teacherclasseslistwork(params) {
	return POST(urls + '/teacher/classes/list-by-work', params, 'get', '')
}
//查询课时列表
export function courselessonlist(params) {
	return POST(fuUrl + '/course/lesson/list', params, 'get', '')
}
//GET /course/lesson/{id}获取课时详情【课时ID】
export function courselessonid(params) {
	return POST(fuUrl + '/course/lesson/' + params.id, '', 'get', '')
}
//GET /CcPlayback/queryRoomPlayBackList查询回放列表
// export function CcPlaybackqueryRoomPlayBackList(params) {
// 	return POST(urls + '/CcPlayback/queryRoomPlayBackList', params, 'get', '')
// }
//登陆用户:查询自己全部角色权限菜单
export function menutreeuser(params) {
	return POST(urls + '/menu/tree-by-user', params, 'get', '')
}
//获取学科列表
export function subjeclist(params) {
	return POST(urls + '/subject/list', params, 'get', '')
}
//获取教师所教学科列表
export function teachersubject(params) {
	return POST(urls + '/teacher/subject/list-by-work', params, 'get', '')
}
//教材-获取教材版本列表
export function courseversion(params) {
	return POST(fuUrl + '/course/version/list', params, 'get', '')
}
//教材-获取学科列表
export function coursesubjectlist(params) {
	return POST(fuUrl + '/course/subject/list', params, 'get', '')
}
//教材-获取（年级）册别列表
export function coursevolumelist(params) {
	return POST(fuUrl + '/course/volume/list', params, 'get', '')
}
//根据学科id、版本id、（年级）册别id获取教材章节树
export function bookchaptertreevo(params) {
	return POST(fuUrl + '/book/get-chaptertree-vo', params, 'get', '')
}
//获取课程分类
export function courseclassifylist(params){
	return POST(fuUrl + '/course/classify/list?parentId=0&groupId=1', params, 'get', '')
}
//获取课程列表
export function courselist(params) {
	return POST(fuUrl + '/course/list', params, 'get', '')
}
//获取课时详情【课时ID】
export function courselesson(params) {
	return POST(fuUrl + '/lesson/get-lesson', params, 'get', '')
}
//课程详情-新增浏览量
export function lessonsetview(params) {
	return POST(fuUrl + '/lesson/set-view?lessonId=' + params.lessonId, '', 'post', '')
}
//听课记录-填写听课评价
export function lessonfeeling(params) {
	return POST(fuUrl + '/lesson/feeling', params, 'post', '')
}
//听课感受-获取听课感受（评论-分页）
export function lessonfeelinglist(params) {
	return POST(fuUrl + '/lesson/feeling/list', params, 'get', '')
}
//听课感受-删除一条听课感受（评论）
export function lessonfeelingdel(params) {
	return POST(fuUrl + '/lesson/feeling/deleteById', params, 'post','', '4')
}
//听课记录-获取课程列表
export function notelist(params) {
	return POST(fuUrl + '/note/list', params, 'get', '')
}
//观课记录-添加/更新一条观课记录
export function note(params) {
	return POST(fuUrl + '/note', params, 'post', '')
}
//观课记录-查询是否已添加观课记录【有则返回观课记录】
export function notecheckIsExist(params) {
	return POST(fuUrl + '/note/checkIsExist', params, 'get', '')
}
//获取课程详情（含课时）
export function course(params) {
	return POST(fuUrl + '/course/' + params.id, '', 'get', '')
}
//观课记录-根据课程ID观课笔记详情
export function noteid(params) {
	return POST(fuUrl + '/note/' + params.id, '', 'get', '')
}
//观课记录-填写观课记录
export function notesaveevaluate(params) {
	return POST(fuUrl + '/note/save-evaluate', params, 'post', '')
}

// 新增浏览量
export function lessonSetView(params) {
	return POST(fuUrl + '/lesson/set-view', params, 'post', '', '4')
}
// PC端用户进入观看直播
export function PCIntoInsert(params) {
	return POST(fuUrl + '/declare/PCIntoInsert', params, 'post', '')
}
// PC端用户退出观看直播
export function PcQuitUpate(params) {
	return POST(fuUrl + '/declare/PcQuitUpate', params, 'post', '')
}
// 获取直播课表 分页
export function lessonOnList(params) {
	return POST(fuUrl + '/course/lesson/on-line/list',params, 'get', '')
}
// 获取当前周次
export function getCurrentWeek(params) {
	return POST(fuUrl + '/course/weeks/getCurrentWeek',params, 'get', '')
}
// 观众列表信息
export function viewerWatchRecord(params) {
	return POST(fuUrl + '/declare/viewerWatchRecord',params, 'get', '')
}
// 点赞数量
export function lessonZan(params) {
	return POST(fuUrl + '/lesson/zan', params, 'post', '','4')
}
// 评论点赞
export function feelingZan(params) {
	return POST(fuUrl + '/lesson/feeling/zan', params, 'post', '','4')
}
export function feelingCancelZan(params) {
	return POST(fuUrl + '/lesson/feeling/cancelZan', params, 'post', '','4')
}
// export function PcQuitUpate(params) {
// 	return chuli(urls+'/declare/PcQuitUpate', 'post', params)
// }
// 课程详情-获取直播状态
export function getLiveStatus(params) {
	return POST(fuUrl + '/lesson/getLiveStatus',params, 'get', '')
}
// 字典
export function dictcode(params) {
	return POST(urls + `/dict/code`, params, 'get', '')
}
//新增或编辑课程信息
export function saveCourse(params) {
	return POST(fuUrl + `/course`, params)
}
// 小组列表携带成员
export function getUserList(params) {
	return POST(urls + '/course/team/getUserList', params, 'get', '')
}
// 获取学校列表
export function getSchoolList(params) {
	return POST(urls + `/school/list`, params, 'get')
}
// 获取上传资源类型
export function getResTypeList(params) {
	return POST(fuUrl + `/res/types/list`, params, 'get')
}
//课程详情-根据课时ID获取推流地址
export function lessongetPushUrl(params) {
	return POST(fuUrl + `/lesson/getPushUrl`, params, 'get', '')
}
//新增或编辑课时
export function saveCourseLesson(params) {
	return POST(fuUrl + `/course/lesson`, params)
}
// 获取名师列表
export function getTeacherList(params) {
	return POST(urls + `/teacher/list`, params, 'get')
}
// 根据申报录课主键ID查询申报录课信息
export function selectByPrimaryKey(params) {
	return POST(fuUrl + '/declare/selectByPrimaryKey', params, 'get', '')
}
// 获取课程详情
export function getCourseInfo(params) {
	return POST(fuUrl + `/course/` + params.id, {}, 'get')
}
//分类
export function courseclassify() {
	return POST(fuUrl + `/course/classify/list?parentId=0&groupId=1`, '', 'get', '')
}
// 获取学科列表
export function getSubjectList(params) {
	return POST(urls + `/subject/list`, params, 'get')
}
// 分页查询OSS对象
export function queryVideoList(params) {
	return POST(fuUrl + '/aliyunOss/queryVideoList', params, 'get', '')
}
// 获取年级列表
export function getGradeList(params) {
	return POST(urls + `/grade/gradelist`, params, 'get')
}
// 获取教材列表
export function getBookList(params) {
	return POST(fuUrl + `/book/list`, params, 'get')
}
//上传附件
export function uploadFile(params) {
	return POST(urls + `/file/file-upload`, params)
}
// 删除课时
export function deleteLesson(params) {
	return POST(fuUrl + `/course/lesson/` + params.id, {}, 'delete')
}
// 获取教材章节树
export function getBookTreeList(params) {
	return POST(fuUrl + `/book/getchaptertree`, params, 'get')
}
// 获取学校添加课程次数
export function getCourseRight(params) {
	return POST(fuUrl + `/course/getCourseRight`, params, 'get')
}



// WEBPACK FOOTER //
// ./src/api/home.js